import { message } from '@linktivity/link-ui';
import { Firebase } from '@linktivity/link-utils';
import i18n from '@link/admin/i18n';
import { config as env } from '@link/admin/utils/env';

const firebaseConfig = {
  apiKey: env.firebaseApiKey,
  authDomain: env.firebaseAuthDomain
};

const SILENT_ERROR_CODES = [
  'auth/popup-closed-by-user',
  'auth/cancelled-popup-request'
];

class AdminFirebase extends Firebase {
  showErrorMessage(error: { code: string; message: string }) {
    const { code, message: defaultMessage } = error;

    if (SILENT_ERROR_CODES.includes(code)) {
      return;
    }

    message.error(
      i18n.exists(`firebase.${code}`)
        ? i18n.t(`firebase.${code}`)
        : defaultMessage
    );
  }
}

const adminAuth = new AdminFirebase(firebaseConfig);

if (env.firebaseTenantId) {
  adminAuth.setTenantId(env.firebaseTenantId);
}

export default adminAuth;
